import LanguageCode from '../types/language';

export const RTL_LANGUAGES = ['ar'] as const;

export function isRtlLanguage(language: LanguageCode): boolean {
	return (RTL_LANGUAGES as readonly LanguageCode[]).includes(language);
}

export function applyDocumentLanguage(language: LanguageCode): void {
	document.documentElement.lang = language;
	document.documentElement.dir = isRtlLanguage(language) ? 'rtl' : 'ltr';
}
